import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageSaintJulien: React.FC = () => (
  <LocalSeoPage
    city="Saint-Julien-en-Genevois"
    cityShort="Saint-Julien"
    slug="depannage-informatique-saint-julien-en-genevois"
    metaTitle="Dépannage Informatique Saint-Julien-en-Genevois | SOS IT"
    metaDescription="Technicien informatique à Saint-Julien-en-Genevois. Réparation PC, virus, WiFi. Intervention à domicile ou à distance. Devis gratuit."
    intro="Vous êtes à Saint-Julien-en-Genevois et votre ordinateur ne fonctionne plus correctement ? Notre technicien intervient rapidement, à votre domicile ou à distance. Virus, PC lent, connexion WiFi en panne, Windows bloqué — nous trouvons la solution sans jargon technique."
    postalCode="74160"
    nearbyTowns={[
      { name: 'Viry', link: '/depannage-informatique-viry' },
      { name: 'Valleiry', link: '/depannage-informatique-valleiry' },
      { name: 'Annemasse', link: '/depannage-informatique-annemasse' },
      { name: 'Gex', link: '/depannage-informatique-gex' },
      { name: 'Saint-Genis-Pouilly', link: '/depannage-informatique-saint-genis-pouilly' },
      { name: 'Ferney-Voltaire', link: '/depannage-informatique-ferney-voltaire' },
      { name: 'Archamps', link: '/depannage-informatique-archamps' },
      { name: 'Collonges-sous-Salève', link: '/depannage-informatique-collonges-sous-saleve' },
      { name: 'Neydens' },
      { name: 'Présilly' },
      { name: 'Beaumont' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Viry', href: '/depannage-informatique-viry' },
      { label: 'Dépannage informatique à Valleiry', href: '/depannage-informatique-valleiry' },
      { label: 'Dépannage informatique à Annemasse', href: '/depannage-informatique-annemasse' },
      { label: 'Dépannage informatique à Gex', href: '/depannage-informatique-gex' },
      { label: 'Dépannage informatique à Saint-Genis-Pouilly', href: '/depannage-informatique-saint-genis-pouilly' },
      { label: 'Dépannage informatique à Ferney-Voltaire', href: '/depannage-informatique-ferney-voltaire' },
      { label: 'Dépannage informatique à Archamps', href: '/depannage-informatique-archamps' },
      { label: 'Dépannage informatique à Collonges-sous-Salève', href: '/depannage-informatique-collonges-sous-saleve' },
      { label: 'Dépannage informatique dans la région de Genève', href: '/depannage-informatique-region-geneve' },
    ]}
  />
);

export default DepannageSaintJulien;
